// คำนวณสภาพคล่องพื้นฐาน เป้าหมายเงินสำรอง และสถานะจากค่าดิบชุดเดียวกัน โดยไม่รวมเงินออมหรือลงทุนในตัวหาร
export const calculateBasicLiquidityRatio = ({ balanceData }) => {
  const liquidAssets = Number(balanceData?.sum_property_asset || 0);
  const annualFixedAndVariableExpense =
    Number(balanceData?.sum_expenses_fixed || 0) +
    Number(balanceData?.sum_expenses_variable || 0);
  const monthlyExpense = annualFixedAndVariableExpense / 12;
  const targetLiquidAssets = monthlyExpense * 6;
  const reserveDifference = liquidAssets - targetLiquidAssets;
  const ratio = monthlyExpense > 0 ? liquidAssets / monthlyExpense : 0;
  let status = "no_data";

  if (liquidAssets > 0 && monthlyExpense > 0) {
    if (ratio < 6) {
      status = "bad";
    } else if (ratio === 6) {
      status = "good";
    } else {
      status = "chance";
    }
  }

  return {
    liquidAssets,
    annualFixedAndVariableExpense,
    monthlyExpense,
    targetLiquidAssets,
    reserveDifference,
    ratio,
    status,
  };
};
